import React, { useState } from "react";
import { Block } from "app/shared/components/blocks/block";
import { Pressable, ScrollView, StyleSheet, View } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTranslation } from "react-i18next";
import { useDesktopMediaQuery, useMobileMediaQuery } from "app/shared/util/media-query";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "@styles/spacing";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import FormCardDetail from "./form-card/form-card-detail";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { useDispatch, useSelector } from "react-redux";
import {
  getCardListSelector,
  getCardStoreSelector,
  getLimit4NumDigitSelector,
  getResponseCardDetailSelector,
  getStatusListCardSelector,
} from "../reducer/selectors";
import { CARDITEM } from "app/shared/services/services-model.type";
import StackParamsList from "app/navigation/nav-stack-params";
import {
  fetchCardActivateRequest,
  fetchCardAuthorizationSuccess,
  fetchCardDetailRequest,
  fetchCardFullNumRequest,
  fetchCardListRequest,
  fetchCardUpdateEComStatusRequest,
  fetchCardUpdateStatusRequest,
  setCardReset,
  setCardStore,
  setLimit4NumDigit,
} from "../reducer/actions";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import { StackSpacing } from "app/shared/components/spacing";
import fixture from "./__test__/fixture.json";
import CardSwipe from "./form-card/card-swipe-web";
import CardSwipeMobile from "./form-card/card-swipe-mobile";
import { showModal } from "app/modules/modal-management/reducer/action";
import { Constant } from "app/shared/constant/constant";
import { setPaymentCardReset } from "../payment-card/reducer/actions";
import { Limit4NumberDigit } from "../reducer/types";
import { pushAppFlyer, pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.LIST_CARDS>;

export interface ParamCardRequest {
  cardID: string;
  status?: boolean;
  suffix?: string;
}

export const SWITCH_ACTION = {
  GET_LIST_CARD: 0,
  GET_DETAIL: 1,
  ACTIVATED_CARD: 2,
  ACTIVATED_ACCEPT: 3,
  HOT_STATUS: 4,
  E_COM_STATUS: 5,
  SHOW_FULL_NUM: 6,
  PAYMENT_CARD_STATEMENT: 7,
  PAYMENT_CARD: 8,
  CARD_HISTORY: 9,
  PHYSICAL_REGISTER: 10,
};

const ListCard = () => {
  const { colors, fonts } = useTheme();
  const { t, i18n } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const isMobile = useMobileMediaQuery();
  const { dispatch, navigate } = useNavigation();
  const dispatchStore = useDispatch();
  const routeProps = useRoute<ProfileScreenRouteProp>();

  const cardStore = useSelector(getCardStoreSelector);
  const listCardStore = useSelector(getCardListSelector);
  const cardListStatus = useSelector(getStatusListCardSelector);
  const cardDetailStore = useSelector(getResponseCardDetailSelector);
  const limit4NumDigitStore = useSelector(getLimit4NumDigitSelector);
  const contactId = useSelector(getContactIdSelector);
 
  const [selectIndex, setSelectIndex] = useState<number>(0);
  const [listCards, setListCard] = useState<CARDITEM[]>([]);
  const [cardSelect, setCardSelect] = useState<CARDITEM | undefined>();
  const [updateStatusList, setUpdateStatusList] = useState<boolean>(false);
  const [updateDetail, setUpdateDetail] = useState<boolean>(false);

  const goHome = () => {
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => goHome(),
    },
    {
      name: t("CARD_DICH_VU_THE"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        viewContainer: { flexDirection: "row", flexWrap: "wrap" },
        viewEmpty: { maxWidth: isDesktop ? "25%" : "50%", minWidth: isDesktop ? "25%" : "50%" },
        textName: { ...fonts.medium, color: colors.text, textAlign: "center", fontSize: 14, maxWidth: 156 },
        pressAble: { alignSelf: "center" },
        button: { display: isDesktop ? "flex" : "none" },
        menuStyle: { borderRadius: spacing.small },
      }),
    [colors.text, fonts.medium, isDesktop],
  );

  const onPressItemList = (index: number) => {
    switch (index) {
      case 0:
        handlerAction(SWITCH_ACTION.PHYSICAL_REGISTER);
        break;
      default:
        break;
    }
  };

  const handlerParamsAppFlyer = (action: string) => {
    console.log("handlerParamsAppFlyer");
    //activated, set_default_payment, lock, lock_online_transaction
    return {
      eventName: "af_setup_card",
      params: {
        af_channel: "ib_rb",
        af_setup_card_action: action,
      },
    };
  };

  const eventPushCleverTap = (status?: boolean, response?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (status?: boolean, response?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_error_message: status === false ? response || "" : "",
    };

    if (status !== undefined) {
      param = {
        ...param,
        ct_issuecard_clickbuttonregister_status: status ? "success" : "failure",
      };
    }
    return {
      eventNameCT: "ct_issuecard_clickbuttonregister",
      paramsCT: param,
    };
  };

  const handlerAction = React.useCallback(
    (index: number, param?: ParamCardRequest) => {
      switch (index) {
        case SWITCH_ACTION.GET_LIST_CARD:
          dispatchStore(fetchCardListRequest(undefined, true));
          break;
        case SWITCH_ACTION.GET_DETAIL:
          dispatchStore(fetchCardDetailRequest(param?.cardID || ""));
          break;
        case SWITCH_ACTION.ACTIVATED_ACCEPT:
          const dataActivated = handlerParamsAppFlyer("activated");
          pushAppFlyer(dataActivated.eventName, dataActivated.params);
          dispatchStore(fetchCardActivateRequest(param));
          break;
        case SWITCH_ACTION.HOT_STATUS:
          const dataLock = handlerParamsAppFlyer("lock");
          pushAppFlyer(dataLock.eventName, dataLock.params);
          dispatchStore(fetchCardUpdateStatusRequest(param?.cardID, param?.status));
          break;
        case SWITCH_ACTION.E_COM_STATUS:
          const dataLockInlineTrans = handlerParamsAppFlyer("lock_online_transaction");
          pushAppFlyer(dataLockInlineTrans.eventName, dataLockInlineTrans.params);
          dispatchStore(fetchCardUpdateEComStatusRequest(param?.cardID, param?.status));
          break;
        case SWITCH_ACTION.SHOW_FULL_NUM:
          dispatchStore(fetchCardFullNumRequest(param?.cardID));
          break;
        case SWITCH_ACTION.PAYMENT_CARD:
          let cardNavigate: CARDITEM | undefined;
          if (listCards.length) {
            cardNavigate = listCards[selectIndex].cardType === Constant.CARD.CARD_TYPE.CREDIT ? listCards[selectIndex] : undefined;
          }
          dispatchStore(setPaymentCardReset());
          dispatch(
            StackActions.replace(ScreenNameType.PAYMENT_CARD_CREATE, {
              resetData: true,
              card: cardNavigate,
              preScreen: ScreenNameType.LIST_CARDS,
            }),
          );
          break;
        case SWITCH_ACTION.PAYMENT_CARD_STATEMENT:
          dispatch(StackActions.replace(ScreenNameType.CARD_STATEMENT, { card: listCards[selectIndex] }));
          break;
        case SWITCH_ACTION.CARD_HISTORY:
          dispatch(StackActions.replace(ScreenNameType.CARD_HISTORY, { card: listCards[selectIndex] }));
          break;
        case SWITCH_ACTION.PHYSICAL_REGISTER:
          eventPushCleverTap(true, undefined);
          dispatch(StackActions.replace(ScreenNameType.CARD_PHYSICAL_HISTORY));
          break;
        default:
          break;
      }
    },
    [dispatch, dispatchStore, listCards, selectIndex],
  );

  const FormEmpty =
    cardListStatus !== "pending" && !listCards.length ? (
      <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0}>
        <View style={styles.viewContainer}>
          {fixture.funcitons[0].children.map((_item, _index) => (
            <View key={_index} style={styles.viewEmpty}>
              <Pressable style={styles.pressAble} key={_index} onPress={() => onPressItemList(_index)}>
                {({ hovered }: PressAbleState) => {
                  // eslint-disable-next-line react-hooks/rules-of-hooks
                  const _buttonStyle = useAnimatedStyle(() => {
                    return {
                      justifyContent: "center",
                      alignItems: "center",
                      transform: [
                        {
                          scale: hovered ? withSpring(1.06) : withSpring(1),
                        },
                      ],
                    };
                  });
                  return (
                    <Animated.View style={_buttonStyle}>
                      <Block br={20} p={spacing.huge} bg={colors.backgroundForm} middle center>
                        <IconsYellowBanking name={_item.icon} size={64} />
                      </Block>
                      <StackSpacing size="small" />
                      <Text numberOfLines={2} style={styles.textName}>
                        {i18n.language === "vi" ? _item.name.vi : _item.name.en}
                      </Text>
                      <StackSpacing size="medium" />
                    </Animated.View>
                  );
                }}
              </Pressable>
            </View>
          ))}
        </View>
      </Block>
    ) : (
      <></>
    );

  const FormSwipe =
    listCards.length > 0 ? (
      isMobile ? (
        <CardSwipeMobile listCards={listCards} selectIndex={selectIndex} onChangeIndex={setSelectIndex} requestDetail={handlerAction} />
      ) : (
        <CardSwipe listCards={listCards} selectIndex={selectIndex} onChangeIndex={setSelectIndex} requestDetail={handlerAction} />
      )
    ) : (
      <></>
    );

  const FormCard =
    listCards.length > 0 ? (
      <FormCardDetail
        card={cardSelect}
        actionClick={handlerAction}
        updateListCard={() => setUpdateDetail(true)}
        onCancel={() => goHome()}
      />
    ) : (
      <></>
    );

  React.useEffect(() => {
    setListCard(listCardStore || []);
  }, [listCardStore]);

  React.useEffect(() => {
    if (listCards) {
      setCardSelect(listCards[selectIndex]);
    }
  }, [listCards, selectIndex]);

  React.useEffect(() => {
    if (
      updateStatusList === true &&
      listCards.length &&
      listCards[selectIndex] &&
      cardDetailStore?.cardId &&
      cardDetailStore?.cardId === listCards[selectIndex].cardId
    ) {
      setUpdateStatusList(false);
      const listNew: CARDITEM[] = listCards.map((_item) => {
        if (_item.cardId === cardDetailStore?.cardId) {
          _item.hotStatus = cardDetailStore.hotStatus;
          _item.ecomStatus = cardDetailStore.ecomStatus;
          _item.cardNum = cardDetailStore.cardNum;
        }
        return _item;
      });
      dispatchStore(setCardStore({ ...cardStore, resListCard: listNew }));
    }
  }, [cardDetailStore, cardStore, dispatchStore, listCards, selectIndex, updateStatusList]);

  React.useEffect(() => {
    if (listCards.length && updateDetail === true) {
      setUpdateDetail(false);
      handlerAction(SWITCH_ACTION.GET_DETAIL, { cardID: listCards[selectIndex].cardId || "" });
      setUpdateStatusList(true);
    }
  }, [handlerAction, listCards, selectIndex, updateDetail]);

  React.useEffect(() => {
    let arrayLimit: Limit4NumberDigit[] = [];
    if (listCardStore?.length) {
      if (!limit4NumDigitStore?.length) {
        // Tạo mới Limit
        listCardStore.forEach((item) => {
          if (item.hotStatus === "1") {
            arrayLimit.push({ cardID: item.cardId || "", limit: 3 });
          }
        });
        // console.log("Tạo mới Limit");
      } else {
        // Update thẻ chưa kích hoạt
        arrayLimit = limit4NumDigitStore;
        listCardStore.forEach((_item) => {
          if (_item.hotStatus === "1") {
            const filters = limit4NumDigitStore.filter((_itemLimit) => {
              return _itemLimit.cardID === _item.cardId && _item.hotStatus === "1";
            });
            if (!filters.length) arrayLimit.push({ cardID: _item.cardId || "", limit: 3 });
          }
          return;
        });
        // console.log("Update thẻ chưa kích hoạt");
      }

      dispatchStore(setLimit4NumDigit(arrayLimit));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchStore, listCardStore]);

  React.useEffect(() => {
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setCardReset());
      let showLoading = true;
      if (listCardStore?.length) showLoading = false;
      dispatchStore(fetchCardListRequest(undefined, showLoading));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchStore, routeProps?.params?.resetData]);

  React.useEffect(() => {
    if ((cardStore.statusListCard === "ok" && !listCardStore?.length) || cardStore.statusListCard === "error") {
      dispatchStore(
        showModal({
          modalType: "alert",
          modalProps: {
            open: true,
            message: t("CARD_BAN_CHUA_DANG_KI_LOAI_THE_NAY"),
          },
        }),
      );
      dispatchStore(setCardStore({ ...cardStore, statusListCard: "init" }));
    }
  }, [dispatchStore, listCardStore?.length, t, cardStore]);

  React.useEffect(() => {
    if (cardStore.statusCardConfirm === "ok") {
      if (cardStore.resCardConfirm?.verifyRequiredType === "IGNORE") {
        dispatchStore(fetchCardAuthorizationSuccess());
      } else navigate(ScreenNameType.CARD_AUTH);
    }
  }, [navigate, cardStore.statusCardConfirm, cardStore.resCardConfirm?.verifyRequiredType, dispatchStore]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("CARD_DANH_SACH_THE")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          {FormSwipe}
          {FormCard}
          {FormEmpty}
        </Block>
      </ScrollView>
    </Block>
  );
};

export default ListCard;
